import React from 'react';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Identify your "Density"',
    desc: 'Categorize your tasks by brain-drain, not by time.'
  }, {
    num: '02',
    title: 'Order from the Menu',
    desc: 'Use a 5-minute trigger to bypass the "Wall of Awful."'
  }, {
    num: '03',
    title: 'Execute and Reset',
    desc: 'Use the templates to anchor your attention until the task is done.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-[#112240]" data-id="element-67">
      <div className="max-w-5xl mx-auto animate-fade-in-up delay-200" data-id="element-68">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#F1F5F9] mb-16" data-id="element-69">
          How It Works
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-70">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[2px] bg-gradient-to-r from-transparent via-[#2DD4BF]/30 to-transparent" data-id="element-71" />

          {steps.map((step, index) => <div key={index} className="relative flex flex-col items-center text-center group" data-id="element-72">
              <div className="w-24 h-24 rounded-full bg-[#0B1A2E] border-2 border-[#2DD4BF] flex items-center justify-center mb-6 relative z-10 shadow-[0_0_15px_rgba(45,212,191,0.2)] group-hover:scale-110 transition-transform duration-300" data-id="element-73">
                <span className="text-3xl font-serif font-bold text-[#2DD4BF]" data-id="element-74">
                  {step.num}
                </span>
              </div>
              <h3 className="text-xl font-bold text-[#F1F5F9] mb-3" data-id="element-75">
                {step.title}
              </h3>
              <p className="text-[#94A3B8] leading-relaxed max-w-xs" data-id="element-76">
                {step.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}